import * as React from "react";
import AgGrid from "app/components/AgGrid";
import useAxiosPrivate from "app/hooks/useAxiosPrivate";
import {
    Button,
    Col,
    DateRangePicker,
    Divider,
    Grid,
    Heading,
    Message,
    Panel,
    Row,
    Stack,
    useToaster,
} from "rsuite";
import SideDrawer from "app/components/SideDrawer";
import { LoadingButton } from "@mui/lab";
import { Autocomplete, TextField } from "@mui/material";
import { Field, Formik } from "formik";
import { DateField, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import moment from "moment";
import * as yup from "yup";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { DeleteForever } from "@mui/icons-material";
import useAuth from "app/hooks/useAuth";

import { useTheme } from "@emotion/react";
//import { useProps } from "./PolicyProvider";

import { addDays } from "date-fns";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import addMonths from "date-fns/addMonths";

import { startOfToday } from "date-fns";
import useAPINew from "app/hooks/useAPINew";
import { DELETE_PREMIUMPOINT, EDIT_PREMIUMPOINT } from "Permissions";
import { toAmnt } from "functions";

import { useNavigate } from "react-router-dom";

function getLastFinancialYearDates() {
    const today = startOfToday();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    let startOfLastFY, endOfLastFY;

    if (currentMonth >= 3) {
        // From April to December
        startOfLastFY = new Date(currentYear - 1, 3, 1); // April 1st of last year
        endOfLastFY = new Date(currentYear, 2, 31); // March 31st of this year
    } else {
        // From January to March
        startOfLastFY = new Date(currentYear - 2, 3, 1); // April 1st two years ago
        endOfLastFY = new Date(currentYear - 1, 2, 31); // March 31st of last year
    }

    return {
        startOfLastFY,
        endOfLastFY,
    };
}

const { startOfLastFY, endOfLastFY } = getLastFinancialYearDates();

function getCurrentFinancialYearDates() {
    const today = startOfToday();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    let startOfCurrentFY, endOfCurrentFY;

    if (currentMonth >= 3) {
        // From April to December
        startOfCurrentFY = new Date(currentYear, 3, 1); // April 1st of this year
        endOfCurrentFY = new Date(currentYear + 1, 2, 31); // March 31st of next year
    } else {
        // From January to March
        startOfCurrentFY = new Date(currentYear - 1, 3, 1); // April 1st of last year
        endOfCurrentFY = new Date(currentYear, 2, 31); // March 31st of this year
    }

    return {
        startOfCurrentFY,
        endOfCurrentFY,
    };
}

const { startOfCurrentFY, endOfCurrentFY } = getCurrentFinancialYearDates();

const predefinedRanges = [
    {
        label: "Today",
        value: [new Date(), new Date()],
    },
    {
        label: "Yesterday",
        value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    },
    {
        label: "This week",
        value: [startOfWeek(new Date()), endOfWeek(new Date())],
    },
    {
        label: "Last 7 days",
        value: [subDays(new Date(), 6), new Date()],
    },
    {
        label: "Last 30 days",
        value: [subDays(new Date(), 29), new Date()],
    },
    {
        label: "Last Fin Year",
        value: [startOfLastFY, endOfLastFY],
    },
    {
        label: "Current Fin Year",
        value: [startOfCurrentFY, endOfCurrentFY],
    },
    {
        label: "This month",
        value: [startOfMonth(new Date()), endOfMonth(new Date())],
    },
    {
        label: "Last month",
        value: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1)),
        ],
    },
    {
        label: "Tomorrow",
        value: [addDays(new Date(), 1), addDays(new Date(), 1)],
    },
    {
        label: "Next week",
        value: [
            startOfWeek(addDays(new Date(), 6)),
            endOfWeek(addDays(new Date(), 6)),
        ],
    },
    {
        label: "Next 7 days",
        value: [new Date(), addDays(new Date(), 6)],
    },
    {
        label: "Next 30 days",
        value: [new Date(), addDays(new Date(), 29)],
    },
    {
        label: "Next month",
        value: [
            startOfMonth(addMonths(new Date(), 1)),
            endOfMonth(addMonths(new Date(), 1)),
        ],
    },
];

const validationSchema = yup.object({});

export default function ListLICInvoiceData() {


    const axiosPrivate = useAxiosPrivate();
    const { permissions, user } = useAuth();

    const [rowData, setRowData] = React.useState([{}]);
    const [total, setTotal] = React.useState([{}]);

    const PaymentByList = useAPINew("GetPaymentByList.php");
    const CashierList = useAPINew("GetCashierList.php");

    const [loading, setLoading] = React.useState(false);

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const formatNumber = (number) => {
        return Math.floor(number).toLocaleString();
    };
    const formatNumberBalance = (number) => {
        if (number.value < 0) {
            return (number.value * -1).toLocaleString() + " CR";
        } else if (number.value > 0) {
            return (number.value || 0).toLocaleString() + " DR";
        } else {
            return (number.value || 0).toLocaleString();
        }
    };
    const currencyFormatter = (params) => {
        return formatNumber(params.value);
    };
    const formatNumber1 = (number) => {
        if (number.value < 1 && number.value > -1) return 0;
        else return formatNumberBalance(number);
    };

    const [value, setValue] = React.useState([
        startOfMonth(new Date()),
        endOfMonth(new Date()),
    ]);
    var filterParams = {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
            var dateAsString = cellValue;
            if (dateAsString == null) return -1;
            var dateParts = dateAsString.split("/");
            var cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
            );

            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }

            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            }

            if (cellDate > filterLocalDateAtMidnight) {
                return 1;
            }
            return 0;
        },
        minValidYear: 1950,
        maxValidYear: 2050,
        inRangeFloatingFilterDateFormat: "Do MMM YYYY",
        buttons: ["apply", "reset", "clear"],
    };
    const columns = React.useMemo(() => {
        return [
            {
                id: "Date",
                field: "Date",
                minWidth: 120,
                type: "date",
                filter: "agDateColumnFilter",
                filterParams: filterParams,
            },

            {
                id: "InvoiceID", field: "InvoiceID", minWidth: 150,
                cellStyle: {
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer",
                },

            },
            { id: "ValidationID", field: "ValidationID", minWidth: 200 },
            {
                id: "PayDate",
                field: "PayDate",
                minWidth: 120,
                type: "date",
                filter: "agDateColumnFilter",
                filterParams: filterParams,
            },

            {
                id: "TotalCash",
                field: "TotalCash",
                minWidth: 120,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "NoOfTxn",
                field: "NoOfTxn",
                minWidth: 100,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "NoOfCheque",
                field: "NoOfCheque",
                minWidth: 100,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "NoOfPolicies",
                field: "NoOfPolicies",
                minWidth: 100,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "TotalChequeAmnt",
                field: "TotalChequeAmnt",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            {
                id: "TotalInvoiceAmnt",
                field: "TotalInvoiceAmnt",
                minWidth: 100,
                valueFormatter: currencyFormatter,
                filter: "agNumberColumnFilter",
                filterParams: {
                    // pass in additional parameters to the Number Filter
                },
            },
            { id: "MerchantID", field: "MerchantID", minWidth: 150 },
            { id: "CashierName", field: "CashierName", minWidth: 150, width: 150, headerName: "Paid by AC" },
            { id: "Remark", field: "Remark", minWidth: 200 },
            { field: "AddedBy", minWidth: 150, editable: false },
            {
                field: "AddedOn",
                headerName: "Added On",
                minWidth: 180,
                editable: false,
                type: "date",
                filter: "agDateColumnFilter",
                filterParams: filterParams,
            },
            { field: "UniqueID", hide: true, editable: false },
        ];
    }, []);
    const [initialValues, setInitialValues] = React.useState({});
    const toaster = useToaster();
    const GetDataByID = async (ID) => {
        try {
            const responce = await axiosPrivate.post("GetLICInvoiceDataByID.php", {
                UID: ID,
            });
            //console.log(responce);
            const result = responce.data;
            if (result.status === 1) {
                const newData2 = {
                    UniqueID: result.Data[0]?.UniqueID,
                    MerchantID: result.Data[0]?.MerchantID
                        ? {
                            title: result.Data[0]?.MerchantID,
                            value: result.Data[0]?.MerchantID,
                        }
                        : { title: "", value: "" },
                    TotalCash: result.Data[0]?.TotalCash,
                    TotalChequeAmnt: result.Data[0]?.TotalChequeAmnt,
                    TotalInvoiceAmnt: result.Data[0]?.TotalInvoiceAmnt,
                    NoOfTxn: result.Data[0]?.NoOfTxn,
                    NoOfCheque: result.Data[0]?.NoOfCheque,
                    NoOfPolicies: result.Data[0]?.NoOfPolicies,
                    InvoiceID: result.Data[0]?.InvoiceID,
                    ValidationID: result.Data[0]?.ValidationID,
                    Remark: result.Data[0]?.Remark,

                    CashierName: result.Data[0]?.CashierName
                        ? {
                            value: result.Data[0]?.CashierName,
                            title: result.Data[0]?.CashierName,
                        }
                        : { value: "", title: "" },

                    PayDate:
                        result.Data[0].PayDate === "0000-00-00" || result.Data[0].PayDate === null
                            ? null
                            : new Date(result.Data[0].PayDate),
                    Date:
                        result.Data[0].Date === "0000-00-00" || result.Data[0].Date === null
                            ? null
                            : new Date(result.Data[0].Date),
                };
                setInitialValues(newData2);
            }
            if (result.status === 0) {
                toaster.push(
                    <Message type="error" bordered showIcon>
                        <strong>Error!</strong> {result?.Error}
                    </Message>
                );
            }
        } catch (error) {
            console.log(error);
            toaster.push(
                <Message type="error" bordered showIcon>
                    <strong>Error!</strong> Error occured
                </Message>
            );
        }
    };

    const [selectedRowData, setSelectedRowData] = React.useState([]);
    const [filteredRows, setFilteredRows] = React.useState([]);

    React.useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed)
            if (selectedRowData?.UniqueID) {
                GetDataByID(selectedRowData.UniqueID);
            }
        return () => {
            isSubscribed = false;
        };
    }, [selectedRowData?.UniqueID, selectedRowData]);

    const Remove = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui">
                        <h1>{`Are you sure?`}</h1>
                        <p>{`You want to delete this  details.?`}</p>
                        <button onClick={onClose}>No</button>
                        <button
                            onClick={async () => {
                                try {
                                    const datatosend = {
                                        ID: initialValues.UniqueID,
                                    };
                                    const response = await axiosPrivate.post(
                                        "/RemoveLICInvoiceData.php",
                                        datatosend
                                    );
                                    const result = response.data;
                                    if (result.status === 1) {
                                        toaster.push(
                                            <Message type="success" header="Success">
                                                {result.Success}
                                            </Message>,
                                            { placement: "topEnd" },
                                            { duration: 1000 }
                                        );
                                    }
                                    onClose();
                                    onGridReady();
                                    if (result.status === 0) {
                                        toaster.push(
                                            <Message type="error" header="Error">
                                                {`Error occured`}
                                            </Message>,
                                            { placement: "topEnd" },
                                            { duration: 1000 }
                                        );
                                    }
                                } catch (err) {
                                    console.error(err);
                                }
                            }}
                        >
                            Yes, Delete it!
                        </button>
                    </div>
                );
            },
        });
    };

    const clearAll = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui">
                        <h1>{`Are you sure?`}</h1>
                        <p>{`You want to delete all?`}</p>
                        <button onClick={onClose}>No</button>
                        <button
                            onClick={async () => {
                                try {
                                    const datatosend = {
                                        ID: initialValues.UID,
                                    };
                                    const response = await axiosPrivate.post(
                                        "/RemoveAllLICInvoiceData.php",
                                        datatosend
                                    );
                                    const result = response.data;
                                    if (result.status === 1) {
                                        toaster.push(
                                            <Message type="success" header="Success">
                                                {result.Success}
                                            </Message>,
                                            { placement: "topEnd" },
                                            { duration: 1000 }
                                        );
                                    }
                                    onClose();

                                    if (result.status === 0) {
                                        toaster.push(
                                            <Message type="error" header="Error">
                                                {`Error occured`}
                                            </Message>,
                                            { placement: "topEnd" },
                                            { duration: 1000 }
                                        );
                                    }
                                } catch (err) {
                                    console.error(err);
                                }
                            }}
                        >
                            Yes, Delete it!
                        </button>
                    </div>
                );
            },
        });
    };

    const onGridReady = React.useCallback(
        (params) => {
            setLoading(true);
            axiosPrivate
                .post("LoadLICInvoiceData.php", {
                    Start: moment(value[0]).format("YYYY-MM-DD"),
                    End: moment(value[1]).format("YYYY-MM-DD"),
                })
                .then((responce) => {
                    const result = responce.data;
                    if (result.status === 1) {
                        setRowData(result.Data);
                        setTotal(result.Total);
                    } else setRowData([]);
                    setLoading(false);
                })
                .catch((e) => {
                    console.log(e);
                    setLoading(false);
                });
            setLoading(false);
        },
        [value]
    );

    return (
        <>
            <div
                style={{ width: "100%", border: "0.5px dashed #999", borderRadius: 10 }}
            >
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Stack
                        direction="row"
                        spacing={4}
                        style={{ flex: 0.4, justifyContent: "flex-start", padding: 5 }}
                    >
                        <DateRangePicker
                            ranges={predefinedRanges}
                            value={value}
                            onChange={setValue}
                            cleanable={false}
                            showMeridian
                            format="dd-MM-yyyy"
                            defaultCalendarValue={[
                                new Date("2022-02-01"),
                                new Date("2022-03-01"),
                            ]}
                        />
                        <button type="button" className="Button" onClick={onGridReady}>
                            Apply
                        </button>
                    </Stack>
                    <Heading
                        level={5}
                        style={{
                            textAlign: "center",
                            flex: 0.4,
                        }}
                    >
                        {`LIC Invoice Data`}
                    </Heading>
                    <Stack direction="row" spacing={4}>
                        <p>
                            <b>Cash:</b>
                            {toAmnt(total.TotalCash)}
                        </p>
                        <p>
                            <b>ChequeAmnt:</b>
                            {toAmnt(total.TotalChequeAmnt)}
                        </p>
                        <p>
                            <b>InvoiceAmnt:</b>
                            {toAmnt(total.TotalInvoiceAmnt)}
                        </p>

                    </Stack>
                    <Stack
                        direction="row"
                        spacing={2}
                        style={{ flex: 0.2, justifyContent: "flex-end" }}
                    >
                        <Button
                            disabled={!permissions.includes(10000)}
                            onClick={clearAll}
                            appearance="link"
                            startIcon={<DeleteForever />}
                        >
                            Clear All
                        </Button>
                    </Stack>
                </div>
            </div>
            <div
                style={{
                    width: "100%",
                    maxHeight: 600,
                    border: "0.5px dotted #999",
                    marginTop: 5,
                    borderRadius: 10,
                    overflowY: "auto",
                }}
            >
                <Panel>
                    <AgGrid
                        columns={columns}
                        rowData={rowData}
                        onGridReady={onGridReady}
                        defaultColumn={["Name"]}
                        GoTo="/Policy/View"
                        showLoading={loading}
                        onRowSelectedData={setSelectedRowData}
                        handleViewModalOpen={handleOpen}
                        settingsName="LICInvoice"
                        headerComponent={() => <p></p>}
                        setFilteredRows={setFilteredRows}
                        Source="LICInvoice"
                        exportAllowed={true}
                    />
                </Panel>
            </div>
            <SideDrawer
                open={open}
                onClose={handleClose}
                title="Update LIC Invoice Data"
            >
                <Formik
                    validationSchema={validationSchema}
                    initialValues={initialValues}
                    enableReinitialize={true}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        const newData = {
                            ...values,

                            MerchantID: values.MerchantID.value,
                            CashierName: values.CashierName.value,
                            PayDate: moment(values.PayDate).format("YYYY-MM-DD"),
                            Date: moment(values.Date).format("YYYY-MM-DD"),

                        };
                        console.log(newData);
                        try {
                            axiosPrivate
                                .post("EditLICInvoiceData.php", newData)
                                .then((response) => {
                                    const result = response.data;
                                    if (result.status === 1) {
                                        toaster.push(
                                            <Message type="success" bordered showIcon>
                                                <strong>Success!</strong> {result.Success}
                                            </Message>
                                        );

                                        onGridReady();
                                        setSubmitting(false);
                                    }
                                    if (result.status === 0) {
                                        toaster.push(
                                            <Message type="error" bordered showIcon>
                                                <strong>Error!</strong> {result.Error}
                                            </Message>
                                        );
                                        setSubmitting(false);
                                    }
                                })
                                .catch((error) => {
                                    console.error("Error submitting data:", error);
                                    setSubmitting(false);
                                });
                        } catch (e) {
                            console.log(e);
                        } finally {
                            setSubmitting(false);
                        }
                        // updateDatainGrid(newData, values.UniqueID);
                    }}
                >
                    {({
                        values,
                        errors,
                        setFieldValue,
                        handleSubmit,
                        isValidating,
                        isSubmitting,
                        touched,
                        handleBlur,
                        handleChange,
                    }) => {
                        // console.log(errors);
                        // console.log(values);
                        return (
                            <form>
                                <div>
                                    <div className="row">
                                        <Grid fluid style={{ padding: 4 }}>
                                            <Row className="show-grid">
                                                <Col xs={24} sm={24} md={24}>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            display: "flex",
                                                            alignItems: "flex-end",
                                                        }}
                                                    >
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DateField
                                                                label="Date"
                                                                variant="standard"
                                                                size="small"
                                                                name="Date"
                                                                format="dd-MM-yyyy"
                                                                value={values.Date}
                                                                onChange={(value) =>
                                                                    setFieldValue("Date", value, true)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={touched.Date && Boolean(errors.Date)}
                                                                helperText={touched.Date && errors.Date}
                                                            />
                                                        </LocalizationProvider>
                                                    </Row>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            marginLeft: -10,
                                                        }}
                                                    >
                                                        <Autocomplete
                                                            key="ID"
                                                            name={`MerchantID`}
                                                            options={
                                                                CashierList.error ? [null] : CashierList.data
                                                            }
                                                            getOptionLabel={(option) => option?.title}
                                                            disableClearable={true}
                                                            value={
                                                                Boolean(values.MerchantID)
                                                                    ? values.MerchantID
                                                                    : { value: "", title: "" }
                                                            }
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.MerchantID &&
                                                                Boolean(errors.MerchantID)
                                                            }
                                                            helperText={
                                                                touched.MerchantID && errors.MerchantID
                                                            }
                                                            onChange={(_, newValue) => {
                                                                console.log(values);
                                                                console.log(errors);
                                                                setFieldValue(`MerchantID`, newValue, true);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    name="MerchantID"
                                                                    onBlur={handleBlur}
                                                                    error={
                                                                        touched.MerchantID &&
                                                                        Boolean(errors.MerchantID)
                                                                    }
                                                                    helperText={
                                                                        touched.MerchantID && errors.MerchantID
                                                                    }
                                                                    label="Merchant ID"
                                                                    variant="standard"
                                                                />
                                                            )}
                                                            style={{ width: 200 }}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            fullWidth
                                                            name={`InvoiceID`}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.InvoiceID),
                                                            }}
                                                            label="Invoice ID"
                                                            size="small"
                                                            as={TextField}
                                                            placeholder="Enter Invoice ID"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.InvoiceID && Boolean(errors.InvoiceID)
                                                            }
                                                            helperText={touched.InvoiceID && errors.InvoiceID}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            fullWidth
                                                            name={`ValidationID`}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.ValidationID),
                                                            }}
                                                            label="Validation ID"
                                                            size="small"
                                                            as={TextField}
                                                            placeholder="Enter Validation ID"
                                                            onBlur={handleBlur}
                                                            error={touched.ValidationID && Boolean(errors.ValidationID)}
                                                            helperText={touched.ValidationID && errors.ValidationID}
                                                        />
                                                    </Row>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            display: "flex",
                                                            alignItems: "flex-end",
                                                        }}
                                                    >
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DateField
                                                                label="PayDate"
                                                                variant="standard"
                                                                size="small"
                                                                name="PayDate"
                                                                format="dd-MM-yyyy"
                                                                value={values.PayDate}
                                                                onChange={(value) =>
                                                                    setFieldValue("PayDate", value, true)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={touched.PayDate && Boolean(errors.PayDate)}
                                                                helperText={touched.PayDate && errors.PayDate}
                                                            />
                                                        </LocalizationProvider>
                                                    </Row>


                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`TotalCash`}
                                                            fullWidth
                                                            label="TotalCash"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.TotalCash),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Total Cash"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.TotalCash &&
                                                                Boolean(errors.TotalCash)
                                                            }
                                                            helperText={
                                                                touched.TotalCash && errors.TotalCash
                                                            }
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`TotalChequeAmnt`}
                                                            fullWidth
                                                            label="TotalChequeAmnt"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.TotalChequeAmnt),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Total Cheque Amount"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.TotalChequeAmnt &&
                                                                Boolean(errors.TotalChequeAmnt)
                                                            }
                                                            helperText={
                                                                touched.TotalChequeAmnt && errors.TotalChequeAmnt
                                                            }
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`TotalInvoiceAmnt`}
                                                            fullWidth
                                                            label="TotalInvoiceAmnt"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.TotalInvoiceAmnt),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Total Invoice Amount"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.TotalInvoiceAmnt &&
                                                                Boolean(errors.TotalInvoiceAmnt)
                                                            }
                                                            helperText={
                                                                touched.TotalInvoiceAmnt && errors.TotalInvoiceAmnt
                                                            }
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`NoOfTxn`}
                                                            fullWidth
                                                            label="NoOfTxn"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.NoOfTxn),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Number of Transactions"
                                                            onBlur={handleBlur}
                                                            error={touched.NoOfTxn && Boolean(errors.NoOfTxn)}
                                                            helperText={touched.NoOfTxn && errors.NoOfTxn}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`NoOfCheque`}
                                                            fullWidth
                                                            label="NoOfCheque"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.NoOfCheque),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Number of Cheques"
                                                            onBlur={handleBlur}
                                                            error={touched.NoOfCheque && Boolean(errors.NoOfCheque)}
                                                            helperText={touched.NoOfCheque && errors.NoOfCheque}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`NoOfPolicies`}
                                                            fullWidth
                                                            label="NoOfPolicies"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.NoOfPolicies),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Number of Policies"
                                                            onBlur={handleBlur}
                                                            error={touched.NoOfPolicies && Boolean(errors.NoOfPolicies)}
                                                            helperText={touched.NoOfPolicies && errors.NoOfPolicies}
                                                        />
                                                    </Row>

                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            marginLeft: -10,
                                                        }}
                                                    >
                                                        <Autocomplete
                                                            key="ID"
                                                            name={`Payment By`}
                                                            options={
                                                                PaymentByList.error
                                                                    ? [null]
                                                                    : PaymentByList.data
                                                            }
                                                            getOptionLabel={(option) => option?.title}
                                                            disableClearable={true}
                                                            value={
                                                                Boolean(values.CashierName)
                                                                    ? values.CashierName
                                                                    : { value: "", title: "" }
                                                            }
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.CashierName && Boolean(errors.CashierName)
                                                            }
                                                            helperText={touched.CashierName && errors.CashierName}
                                                            onChange={(_, newValue) => {
                                                                console.log(values);
                                                                console.log(errors);
                                                                setFieldValue(`CashierName`, newValue, true);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    name="CashierName"
                                                                    onBlur={handleBlur}
                                                                    error={
                                                                        touched.CashierName &&
                                                                        Boolean(errors.CashierName)
                                                                    }
                                                                    helperText={
                                                                        touched.CashierName && errors.CashierName
                                                                    }
                                                                    label="Cashier Name"
                                                                    variant="standard"
                                                                />
                                                            )}
                                                            style={{ width: 200 }}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`Remark`}
                                                            fullWidth
                                                            label="Remark"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.Remark),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Remark"
                                                            onBlur={handleBlur}
                                                            error={touched.Remark && Boolean(errors.Remark)}
                                                            helperText={touched.Remark && errors.Remark}
                                                        />
                                                    </Row>


                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                    <Divider />
                                    &nbsp; &nbsp;
                                    <>
                                        {(permissions.includes(EDIT_PREMIUMPOINT) ||
                                            user.Type === "SuperAdmin") && (
                                                <LoadingButton
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                    color="secondary"
                                                    variant="contained"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleSubmit(e);
                                                    }}
                                                    loading={isValidating}
                                                    sx={{ my: 2 }}
                                                >
                                                    {isSubmitting ? "Submitting..." : "Submit"}
                                                </LoadingButton>
                                            )}
                                        &nbsp; &nbsp;
                                        {(permissions.includes(DELETE_PREMIUMPOINT) ||
                                            user.Type === "SuperAdmin") && (
                                                <Button
                                                    color="red"
                                                    appearance="primary"
                                                    sx={{ my: 2 }}
                                                    onClick={Remove}
                                                >
                                                    {"Delete"}
                                                </Button>
                                            )}
                                    </>
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </SideDrawer>
            <Styles />
        </>
    );
}
const grey = {
    50: "#F3F6F9",
    100: "#E5EAF2",
    200: "#DAE2ED",
    300: "#C7D0DD",
    400: "#B0B8C4",
    500: "#9DA8B7",
    600: "#6B7A90",
    700: "#434D5B",
    800: "#303740",
    900: "#1C2025",
};

const cyan = {
    50: "#E9F8FC",
    100: "#BDEBF4",
    200: "#99D8E5",
    300: "#66BACC",
    400: "#1F94AD",
    500: "#0D5463",
    600: "#094855",
    700: "#063C47",
    800: "#043039",
    900: "#022127",
};

function useIsDarkMode() {
    const theme = useTheme();
    return theme.palette.mode === "dark";
}

function Styles() {
    // Replace this with your app logic for determining dark mode
    const isDarkMode = useIsDarkMode();
    return (
        <style>{`
        .Button {
          font-family: 'IBM Plex Sans', sans-serif;
          font-weight: 600;
          font-size: 0.875rem;
          line-height: 1.5;
          background-color: ${cyan[500]};
          padding: 8px 16px;
          border-radius: 8px;
          color: white;
          transition: all 150ms ease;
          cursor: pointer;
          border: 1px solid ${cyan[500]};
          box-shadow: 0 2px 4px ${isDarkMode ? "rgba(0, 0, 0, 0.5)" : "rgba(13, 84, 99, 0.5)"
            }, inset 0 1.5px 1px ${cyan[400]}, inset 0 -2px 1px ${cyan[600]};

          &:hover {
            background-color: ${cyan[600]};
          }

          &:active {
            background-color: ${cyan[700]};
            box-shadow: none;
          }

          &:focus-visible {
            box-shadow: 0 0 0 4px ${isDarkMode ? cyan[300] : cyan[200]};
            outline: none;
            }
        }

        .CustomPopup{
          background-color: ${isDarkMode ? grey[900] : "#FFF"};
          border-radius: 8px;
          border: 1px solid ${isDarkMode ? grey[700] : grey[200]};
          box-shadow: ${isDarkMode
                ? `0 4px 8px rgb(0 0 0 / 0.7)`
                : `0 4px 8px rgb(0 0 0 / 0.1)`
            };
          padding: 0.75rem;
          color: ${isDarkMode ? cyan[100] : cyan[700]};
          font-size: 0.875rem;
          font-family: 'IBM Plex Sans', sans-serif;
          font-weight: 500;
          opacity: 1;
          margin: 0.5rem 0px;
        }
    `}</style>
    );
}
